import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import MainLayout from './components/MainLayout';

const LOGIN_PATH = '/admin/login';
const CHANGE_PW_PATH = '/change-password';

/**
 * 路由总入口：
 *   /admin/login       登录（公开）
 *   /change-password   强制改密（公开，但需要 pendingChange 握手态）
 *   /                  受保护（已登录）
 *   *                  未登录跳 /admin/login，已登录进 MainLayout
 *
 * 未登录访问受保护路由时，redirect 把原路径放到 location.state.from，
 * 登录成功后回跳。
 */
function ProtectedShell() {
  const { user, loading, pendingChange } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (pendingChange && pendingChange.changeToken) {
    return <Navigate to={CHANGE_PW_PATH} replace state={{ from: location.pathname }} />;
  }
  if (user) return <MainLayout />;
  return <Navigate to={LOGIN_PATH} replace state={{ from: location.pathname }} />;
}

function App() {
  return (
    <Routes>
      <Route path={LOGIN_PATH} element={<Login />} />
      <Route path={CHANGE_PW_PATH} element={<ChangePassword />} />
      <Route path="*" element={<ProtectedShell />} />
    </Routes>
  );
}

export default App;